import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'service-area-weight-carrier-costs' });

export const { find, create, get, patch, reducer, remove, update } = actions;

export default reducer;
